import { RedoFulfillmentLocationSchema } from "@redotech/redo-model/fulfillments/fulfillment-location";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getLocations = {
  name: "getLocations" as const,
  input: zNull(),
  output: z.object({ locations: z.array(RedoFulfillmentLocationSchema) }),
};
